import React, { useState } from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './AboundSignup.scss';
import AboundNumberScreen from './AboundNumberScreen';
import AboundOTPScreen from './AboundOTPScreen';

const AboundSignup = ({
  jssoCrosswalkObj,
  loginUserCallback,
  handleShowPopUp,
  logout,
}) => {
  const [isOTPScreen, setIsOTPScreen] = useState(false);
  const [number, setNumber] = useState(null);
  const [ssoid, setSsoid] = useState(null);
  const [countryCode, setCountryCode] = useState(null);
  const errorConfig = {
    fpNoEmailOrMobile: 'Mobile Number cannot be left blank.',
    fpInvalidEmail: 'Enter a valid Mobile Number',
    fpInvalidEmailOnly: 'Enter a valid email.',
    fpInvalidMobileOnly: 'Enter a valid Mobile Number',
    accountUnregistered: 'This account is not registered with us.',
    emptyPassword: 'Password cannot be left blank.',
    emptyName: 'Enter your full name.',
    wrongName: 'Enter your name without special character or numbers.',
    wrongPassword: 'Invalid Credentials',
    wrongMobile: 'Invalid Mobile Number',
    wrongEmail: 'Invalid Email Id.',
    expiredOTP: 'The OTP you entered has expired.',
    limitExceeded:
      'Maximum number of unsuccessful attempts exceeded. Please try again later.',
    wrongOtp: 'Enter valid OTP sent to your Mobile Number',
    wrongOtpEmail: 'Enter valid OTP sent to your email.',
    matchLastThree: 'Password cannot match your last three passwords.',
    passwordMismatch: 'Your passwords do not match.',
    captchaUnselected: 'Select the checkbox to proceed.',
    tncNotSelected: 'Accept Terms & Conditions to proceed.',
    userAlreadyRegistered: 'This user is already registered with us.',
    serverError:
      'An error occurred while processing your request. Please try again later.',
    connectionError:
      'There was an error processing your request. Please check your internet connection and try again.',
  };

  const handleOTPScreen = (
    optScreen,
    phoneNumber = null,
    ssoId = null,
    code,
  ) => {
    setIsOTPScreen(optScreen);
    setNumber(phoneNumber);
    setSsoid(ssoId);
    setCountryCode(code);
    if (optScreen) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: 'abound_otp_screen',
        category: 'abound',
      });
    }
  };
  return (
    <div className={s.aboundSignupWrap}>
      {!isOTPScreen ? (
        <AboundNumberScreen
          handleOTPScreen={handleOTPScreen}
          errorConfig={errorConfig}
          jssoCrosswalkObj={jssoCrosswalkObj}
        />
      ) : (
        <AboundOTPScreen
          handleOTPScreen={handleOTPScreen}
          phoneNumber={number}
          ssoid={ssoid}
          errorConfig={errorConfig}
          jssoCrosswalkObj={jssoCrosswalkObj}
          loginUserCallback={loginUserCallback}
          countryCode={countryCode}
          handleShowPopUp={handleShowPopUp}
          logout={logout}
        />
      )}
    </div>
  );
};

export default AboundSignup;
